import { v4 as uuidv4 } from 'uuid';
import TimeCloackImg from '../images/liveClock.png';
import NlwHeatOriginImg from '../images/nlwHeatOrigin.png';
import CurrencyConverter from '../images/currencyConverter.png';
import CalcEasyImg from '../images/calceasy.png';
import AppWeatherImg from '../images/appWeather.png';
import ReactJsCourseImg from '../images/ReactJsCourseImage.png';

const projects = [
  {
    id: uuidv4(),
    name: 'ReactJS ',
    desc: 'Aplicação feita em ReactJs utilizando usestate-Hook e props',
    img: ReactJsCourseImg,
    src: 'https://dio-react-js.vercel.app/',
    code: 'https://gitlab.com/DeW-ill/DIO-ReactJS',
  },
  {
    id: uuidv4(),
    name: 'NLW-HEAT---Origin',
    desc: 'Layout de crachá digital desenvolvido durante a NLW HEAT',
    img: NlwHeatOriginImg,
    src: 'https://wdvops.github.io/NLW-HEAT---Origin/',
    code: 'https://github.com/WdvOps/NLW-HEAT---Origin',
  },
  {
    id: uuidv4(),
    name: 'Currency Converter',
    desc:
      'Conversor de dolar para real desenvolvido durannte Bootcamp Angular, promovido pela DIO - Digital Innovation One',
    img: CurrencyConverter,
    src: 'https://currency-converter-6zjkeczg5-devprojects.vercel.app/',
    code: 'https://github.com/WdvOps/currency_converter',
  },
  {
    id: uuidv4(),
    name: 'CalcEasy',
    desc:
      'Calculadora fácil desenvolvida para fins de estudo de HTML, CSS e Javacript',
    img: CalcEasyImg,
    src: 'https://calc-easy-rep.vercel.app/',
    code: 'https://github.com/WdvOps/calcEasyRep',
  },
  {
    id: uuidv4(),
    name: 'App-weather ',
    desc: 'Aplicação em Angular ligada à open weather API ',
    img: AppWeatherImg,
    src: 'https://app-weather-fxdvmnxyu-devprojects.vercel.app',
    code: 'https://github.com/WdvOps/App-weather',
  },
  {
    id: uuidv4(),
    name: 'Current Time',
    desc:
      'Relógio digital em tempo real desenvolvido como atividade do curso Beginners PRO - Faculdade Iv2',
    img: TimeCloackImg,
    src: 'https://wdvops.github.io/Current-time/',
    code: 'https://github.com/WdvOps/Current-time',
  },
];

export default projects;
